export default __webpack_public_path__ + "static/media/Banner.2b0417f2.mp4";